module.exports = __webpack_public_path__ + "img/media-and-entertainment.464dd87e.webp";